import { useState, useEffect } from 'react';
import { actasService } from '../api/actas';

export const useActas = () => {
  const [actas, setActas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Cargar actas al montar el hook
  useEffect(() => {
    fetchActas();
  }, []);

  const fetchActas = async (filters = {}) => {
    try {
      setLoading(true);
      setError(null);
      const actasData = await actasService.getActas(filters);
      setActas(actasData);
    } catch (err) {
      //console.error('Error fetching actas:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Crear acta
  const createActa = async (actaData, archivos = []) => {//+
    try {
      //console.log('🔄 useActas.createActa - Recibido:', { 
     //   actaData, 
     //   archivos: archivos?.length,
     //   archivosDetalle: archivos?.map(a => a.name)
     // });
      const newActa = await actasService.createActa(actaData, archivos);//+
      setActas(prev => [...prev, newActa]);
      return newActa;
    } catch (err) {
      console.error('Error creating acta:', err);
      throw err;
    }
  };

  // Actualizar acta
  const updateActa = async (numeroConsecutivo, data) => {
    try {
	let response;
	const isFormData = data instanceof FormData;
	if (isFormData) {
		console.log('updateActa - Usando updateWithFiles (FormData)');
		response = await actasService.updateWithFiles(numeroConsecutivo, data);
	} else {
		const cleanData = { ...data };
              	delete cleanData.archivos_nuevos;
              	delete cleanData.archivos_eliminar;
		response = await actasService.updateActa(numeroConsecutivo, cleanData);
	}
	console.log("EEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE")
	// Actualizar estado local
	setActas(prev => prev.map(acta =>
		acta.numero_consecutivo === numeroConsecutivo ? response : acta
	));
	return response;
    } catch (err) {
      	//console.error('Error updating acta:', err);
      	throw err;
    }
  };

  // Eliminar acta
  const deleteActa = async (actaId) => {
    try {
      await actasService.deleteActa(actaId);
      setActas(prev => prev.filter(acta => acta.numero_consecutivo !== actaId));
    } catch (err) {
      //console.error('Error deleting acta:', err);
      throw err;
    }
  };

  const fetchActasByUsuario = async (usuarioUsername, additionalFilters = {}) => {
    setLoading(true);
    try {
      const response = await actasService.getActasByUsuario(usuarioUsername, additionalFilters);
      setActas(response.data.data || response.data);
      setError(null);
    } catch (error) {
      setError(error.message);
      setActas([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchActasByEmpresa = async (empresaNit, additionalFilters = {}) => {
    setLoading(true);
    try {
      const response = await actasService.getActasByEmpresa(empresaNit, additionalFilters);
      setActas(response.data.data || response.data);
      setError(null);
    } catch (error) {
      setError(error.message);
      setActas([]);
    } finally {
      setLoading(false);
    }
  };


  return {
    actas,
    loading,
    error,
    fetchActas,
    createActa,
    updateActa,
    deleteActa,
    fetchActasByUsuario,
    fetchActasByEmpresa,
  };
};
